import React, {Component} from 'react';

import ticket from './img/calls.PNG';
import cv from './img/cvapp.PNG';
import med from './img/medappupdated.PNG';
import mp4 from './img/mp42mp3.PNG';
import menu from './img/restuarantMenu.PNG';
import sales from './img/sales.PNG';
import node from './img/nodeproj.jpg';
import java from './img/java.jpg';


class Portfolio extends Component {
  constructor(props){
    super(props);
    this.state= {
      platform: 'node',
    }
  }

handleSelect = (event) => {
  this.setState({platform: event.target.value});
}

rendernode = () => {
  const color = this.props.color
    return(
      <div>
    <div className="project-row">
      
      <div className={"project-col" + color}>
        <img src={cv} alt="CV APP"/>
        <p className="proj-heading">CV APP</p>
        <p className="proj-descr">A webapp that allows users to create a pdf document CV.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'cvapp')}>View</button>
      </div>

      <div className={"project-col" + color}>
        <img src={node} alt="Presenter Voting"/>
        <p className="proj-heading">Presenter Voting</p>
        <p className="proj-descr">A webapp that allows people to vote for a particular person or group based on their performance.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'voter')}>View</button>
      </div>
      
      <div className={"project-col" + color}>
        <img src={node} alt="Online Store"/>
        <p className="proj-heading">Online Store</p>
        <p className="proj-descr">An online store application.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'shopper')}>View</button>
      </div>
    </div>
    </div>
    )
  }

renderhtml = () => {
  const color = this.props.color
    return(
    <div className="project-row">
      
      <div className={"project-col" + color}>
        <img src={sales} alt="Sales Management"/>
        <p className="proj-heading">Sales Management</p>
        <p className="proj-descr">A sales management web app that allows users to create invoice, stock orders and quotes.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'sales')}>View</button>
      </div>

      <div className={"project-col" + color}>
        <img src={ticket} alt="Ticket Logger"/>
        <p className="proj-heading">Ticket Logger</p>
        <p className="proj-descr">An IT ticket logging application that allows users to log calls for software issues.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'logger')}>View</button>
      </div>
    </div>
    )
  }

renderjava = () => {
  const color = this.props.color
    return(
    <div className="project-row">
      
      <div className={"project-col" + color}>
        <img src={mp4} alt="MP4 to MP3 Converter"/>
        <p className="proj-heading">MP4 to MP3 Converter</p>
        <p className="proj-descr">An Mp4 to MP3 file converter written in Java.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'converter')}>View</button>
      </div>

      <div className={"project-col" + color}>
        <img src={java} alt="Platform Game"/>
        <p className="proj-heading">Platform Game</p>
        <p className="proj-descr">A 2D, side scrawler platform game written in Java.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'platformer')}>View</button>
      </div>

    </div>
    )
  }

rendercs = () => {
  const color = this.props.color
    return(
    <div className="project-row">
      
      <div className={"project-col" + color}>
        <img src={menu} alt="Restuarant POS"/>
        <p className="proj-heading">Restuarant POS</p>
        <p className="proj-descr">A sample restuarant sales POS application written with .Net.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'menu')}>View</button>
      </div>

      <div className={"project-col" + color}>
        <img src={med} alt="Hospital Management"/>
        <p className="proj-heading">Hospital Management</p>
        <p className="proj-descr">A hospital patient, doctor and medicine storage application written with .Net and MSSQL.</p>
        <hr/>
        <button onClick={this.props.alterview.bind(this, 'medapp')}>View</button>
      </div>
    </div>
    )
}

    render(){
      const {
        platform
      } = this.state
      var showPlatform
      
      if(platform === 'node'){
        showPlatform = this.rendernode()
      } else if(platform === 'html'){
        showPlatform = this.renderhtml()
      } else if(platform === 'java'){
        showPlatform = this.renderjava()
      } else if(platform === 'cs'){
        showPlatform = this.rendercs()
      }
      

        return(
        <div className="portfolio">
          <h1 className="portfolio-heading">Portfolio</h1>
          <p className="projectpicker">Pick a platform</p>
          <select value={platform} onChange={this.handleSelect}>
            <option value='node' >NODE</option>
            <option value='html' >HTML/CSS/PHP</option>
            <option value='java' >JAVA</option>
            <option value='cs' >C#</option>
          </select>
          {showPlatform}
        </div>
        )
    }

}

export default Portfolio;